import GameInfoCashier from "../game-info-cashier";
import GameInfoPlayer from "../game-info-player";
import GameTabsStyles from "./styles";
import { useAuth } from "../../core/context/auth.context";
import BlockIcon from "@mui/icons-material/Block";
import { useGame } from "../game.context";
import EmptyStateCard from "../../core/components/empty-state-card.component";

export default function TabInfo() {
  const { isCanceled, reloadGame, isCashier } = useGame();
  const { user } = useAuth();
  const classes = GameTabsStyles();

  if (isCanceled) {
    return <EmptyStateCard message="Game canceled" Icon={BlockIcon} />;
  }

  if (isCashier) {
    return (
      <div className={`${classes.baseContainer} ${classes.statsContainer}`}>
        {!isCanceled && <GameInfoCashier />}
      </div>
    );
  }
  return (
    <div className={`${classes.baseContainer} ${classes.statsContainer}`}>
      <GameInfoPlayer
        user={user}
        onTransactionSent={reloadGame}
        onPlayerStatusChange={reloadGame}
      />
    </div>
  );
}
